import { render, staticRenderFns } from "./CorporationEditForm.vue?vue&type=template&id=620059f9"
import script from "./CorporationEditForm.vue?vue&type=script&lang=js"
export * from "./CorporationEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports